import { useAppearance } from '@fourthwall/appearance';
import { Loading, PillSwitch, Popper, Upload } from '@fourthwall/components';
import EmojiPicker, { EmojiStyle, Theme } from 'emoji-picker-react';
import React, { useState } from 'react';
import { useDashboardFeatureFlags } from '@components/utils/DashboardFeatureFlags';
import { useCreateImageResources } from '@modules/Dashboard/Memberships/hooks/useCreateImageResources';
import * as S from './styled';
export const EmojiInput = ({ emoji, onChange }) => {
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    const [isOpen, setOpen] = useState(false);
    const [tab, setTab] = useState('emoji');
    const { appearance } = useAppearance();
    const { createImageResources, isLoading } = useCreateImageResources();
    const getEmoji = () => {
        if (emoji.startsWith('http')) {
            return React.createElement(S.Image, { src: emoji, alt: "emoji" });
        }
        return React.createElement(S.Emoji, null, emoji);
    };
    const toggleOpen = () => {
        setOpen((prevIsOpen) => {
            return !prevIsOpen;
        });
    };
    const getTheme = () => {
        if (appearance === 'light dark') {
            return Theme.AUTO;
        }
        if (appearance === 'dark') {
            return Theme.DARK;
        }
        return Theme.LIGHT;
    };
    const handleFileDrop = (files) => {
        if (files[0]) {
            createImageResources({
                files: [files[0]],
                onSuccess: (images) => {
                    onChange({
                        type: 'ImageResource',
                        url: images[0].resizedUrl,
                        imageResourceId: images[0].id,
                    });
                    setOpen(false);
                },
            });
        }
    };
    return (React.createElement(Popper, { isOpen: isOpen, referenceComponent: React.createElement(S.Container, { onClick: toggleOpen },
            getEmoji(),
            "Icon"), popperProps: {
            placement: 'bottom-start',
        }, style: { paddingTop: 8 }, onClose: () => setOpen(false) },
        React.createElement(S.PopperContainer, null, dashboardFeatureFlags.membershipsCustomEmoji.enabled ? (React.createElement(Loading, { isLoading: isLoading },
            React.createElement(S.PillSwitchContainer, null,
                React.createElement(PillSwitch, { items: [
                        { label: 'Emoji', value: 'emoji' },
                        { label: 'Image', value: 'image' },
                    ], value: tab, onChange: (value) => (isLoading ? undefined : setTab(value)) })),
            tab === 'emoji' && (React.createElement(EmojiPicker, { autoFocusSearch: false, previewConfig: { showPreview: false }, skinTonesDisabled: true, theme: getTheme(), emojiStyle: EmojiStyle.NATIVE, onEmojiClick: (emoji) => {
                    onChange({
                        type: 'Emoji',
                        emojiIcon: emoji.emoji,
                    });
                    setOpen(false);
                }, width: "100%" })),
            tab === 'image' && (React.createElement(React.Fragment, null,
                React.createElement(S.UploadContainer, null,
                    React.createElement(Upload, { accept: {
                            'image/*': [],
                        }, maxSize: 4194304, disabled: isLoading, iconSize: 32, orientation: "horizontal", title: "", onFileDrop: handleFileDrop })),
                React.createElement(S.UploadInfo, null, "Recommended min. 32 x 32 px icon size"))))) : (React.createElement(EmojiPicker, { autoFocusSearch: false, previewConfig: { showPreview: false }, skinTonesDisabled: true, theme: getTheme(), emojiStyle: EmojiStyle.NATIVE, onEmojiClick: (emoji) => {
                onChange({
                    type: 'Emoji',
                    emojiIcon: emoji.emoji,
                });
                setOpen(false);
            }, width: "100%" })))));
};
